import axios from 'axios';
import { useCallback } from 'react';
import { useDispatch, useSelector, shallowEqual } from 'react-redux';
import fileDownload from 'js-file-download';
import { EXPORT_BOS_API_REQUEST_URL } from '../../../common/apiConfig';
import {
  MANAGE_SUBS_EXPORT_GROUPS_AUDIT_TRAIL_BEGIN,
  MANAGE_SUBS_EXPORT_GROUPS_AUDIT_TRAIL_SUCCESS,
  MANAGE_SUBS_EXPORT_GROUPS_AUDIT_TRAIL_FAILURE,
  MANAGE_SUBS_EXPORT_GROUPS_AUDIT_TRAIL_DISMISS_ERROR,
} from './constants';

export function exportGroupsAuditTrail(args = {}) {
  return (dispatch, getState) => { // optionally you can have getState as the second argument
    dispatch({
      type: MANAGE_SUBS_EXPORT_GROUPS_AUDIT_TRAIL_BEGIN,
    });

    const promise = new Promise((resolve, reject) => {
      const cognitoIdToken = getState().home.auth.cognitoIdToken;
      const token = `Bearer ${cognitoIdToken}`;
      const doRequest = axios({
        url: `${EXPORT_BOS_API_REQUEST_URL}/groupEvents/groupEventExport`,
        method: 'post',
        data: args,
        responseType: 'blob',
        headers: {
          'Authorization': token,
        }
      });
      doRequest.then(
        (res) => {
          dispatch({
            type: MANAGE_SUBS_EXPORT_GROUPS_AUDIT_TRAIL_SUCCESS,
            data: res.data,
          });
          resolve(res);
        },
        // Use rejectHandler as the second argument so that render errors won't be caught.
        (err) => {
          const errorMsg = err && err.response ? err.response.data.message : 'There is an error. Please refresh page or contact administrator.';
          dispatch({
            type: MANAGE_SUBS_EXPORT_GROUPS_AUDIT_TRAIL_FAILURE,
            data: { error: errorMsg },
          });
          reject(err);
        },
      );
    });

    return promise;
  };
}

export function dismissExportGroupsAuditTrailError() {
  return {
    type: MANAGE_SUBS_EXPORT_GROUPS_AUDIT_TRAIL_DISMISS_ERROR,
  };
}

export function useExportGroupsAuditTrail() {
  const dispatch = useDispatch();

  const { exportGroupsAuditTrailPending, exportGroupsAuditTrailError } = useSelector(
    state => ({
      exportGroupsAuditTrailPending: state.manageSubs.exportGroupsAuditTrailPending,
      exportGroupsAuditTrailError: state.manageSubs.exportGroupsAuditTrailError,
    }),
    shallowEqual,
  );

  const boundAction = useCallback((...args) => {
    return dispatch(exportGroupsAuditTrail(...args));
  }, [dispatch]);

  const boundDismissError = useCallback(() => {
    return dispatch(dismissExportGroupsAuditTrailError());
  }, [dispatch]);

  return {
    exportGroupsAuditTrail: boundAction,
    exportGroupsAuditTrailPending,
    exportGroupsAuditTrailError,
    dismissExportGroupsAuditTrailError: boundDismissError,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case MANAGE_SUBS_EXPORT_GROUPS_AUDIT_TRAIL_BEGIN:
      // Just after a request is sent
      return {
        ...state,
        exportGroupsAuditTrailPending: true,
        exportGroupsAuditTrailError: null,
      };

    case MANAGE_SUBS_EXPORT_GROUPS_AUDIT_TRAIL_SUCCESS:
      // The request is success
      fileDownload(action.data, "Create Groups Audit Trail Reports.xlsx");
      return {
        ...state,
        exportGroupsAuditTrailPending: false,
        exportGroupsAuditTrailError: null,
      };

    case MANAGE_SUBS_EXPORT_GROUPS_AUDIT_TRAIL_FAILURE:
      // The request is failed
      return {
        ...state,
        exportGroupsAuditTrailPending: false,
        exportGroupsAuditTrailError: action.data.error,
      };

    case MANAGE_SUBS_EXPORT_GROUPS_AUDIT_TRAIL_DISMISS_ERROR:
      // Dismiss the request failure error
      return {
        ...state,
        exportGroupsAuditTrailError: null,
      };

    default:
      return state;
  }
}
